import { BASE_URL, WORKSHOP_EVALUATION } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { IWorkshopEvaluationInput } from "models/workshopEvaluation";
import { IEvaluation } from "models/EmployeeWorkshopEvaluation";


export async function getWorkshopEvaluation(params: string = "") {
  const response = await axios.get(BASE_URL + WORKSHOP_EVALUATION + params);
  return response.data;
}

export async function getEvaluationQuestions(params: string = ""): Promise<IEvaluation> {
  const response = await axios.get(BASE_URL + WORKSHOP_EVALUATION + params);
  return response.data;
}

export async function addWorkshopEvaluation(data: IWorkshopEvaluationInput) {
  const response = await axios.post(BASE_URL + WORKSHOP_EVALUATION, data);
  return response.data;
}
export async function notifyAttendees(data: string) {
  const response = await axios.get(
    BASE_URL + WORKSHOP_EVALUATION + '/notifyattendees',
    { params: { workshopId: data } } 
  );
  return response.data;
}

export async function editWorkshopEvaluation(data: IWorkshopEvaluationInput, id: string) {
  const response = await axios.patch(BASE_URL + WORKSHOP_EVALUATION + "/" + id, data);
  return response.data;
}

export async function deleteWorkshopEvaluation(id: string) {
  const response = await axios.delete(BASE_URL + WORKSHOP_EVALUATION + "/" + id);
  return response.data;
}

export async function getEvaluationProgress(params: string = "") {
  const response = await axios.get(BASE_URL + WORKSHOP_EVALUATION + '/getevaluationprogress' + params);
  return response.data;
}

export async function getEvaluationProgressByWorkshopId(workshopId: string) {
  const response = await axios.get(`${BASE_URL}${WORKSHOP_EVALUATION}/getevaluationprogress?workshopId=${encodeURIComponent(workshopId)}`);
  return response.data;
}

export async function getWorkshopEvaluationByWorkshopId(workshopId: string) {
  const response = await axios.get(`${BASE_URL}${WORKSHOP_EVALUATION}/byworkshop?workshopId=${encodeURIComponent(workshopId)}`);
  return response.data;
}

export const WorkshopEvaluationCells: HeadCell[] = [

  {
    id: "title",
    numeric: false,
    disablePadding: false,
    label: "T_title",
  },
  {
    id: "titleAr",
    numeric: false,
    disablePadding: false,
    label: "T_title_ar",
  },
  {
    id: "isActive",
    numeric: false,
    disablePadding: false,
    label: "T_active",
  },
  {
    id: "timeToComplete",
    numeric: true,
    disablePadding: false,
    label: "T_timeToComplete",
  },
  {
    id: "createdOn",
    numeric: false,
    disablePadding: false,
    label: "T_created_date",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];
